// extracted by mini-css-extract-plugin
export var section = "jobs-module--section--dJuLX";
export var inner_section = "jobs-module--inner_section--147DP";
export var tab_list = "jobs-module--tab_list--_csBH";
export var tab_button = "jobs-module--tab_button--utQ_M";
export var tab_highlight = "jobs-module--tab_highlight--1-Itv";
export var job_header = "jobs-module--job_header--2HbLw";
export var highlighted = "jobs-module--highlighted--FXSIt";
export var job_date = "jobs-module--job_date--14gNJ";
export var job_list = "jobs-module--job_list--2JPMb";